<template>
    <el-dialog title="选择短剧" :visible.sync="innerVisible" class="dialog-table" width="800px" :before-close="closeDialogTable">
        <el-form :inline="true" :model="formInline" ref="formInline" size="small" class="demo-form-inline">
            <el-form-item label="剧目ID" prop="albumId">
                <el-input v-model="formInline.albumId" placeholder="请输入短剧ID" clearable @keyup.enter.native="search" @clear="search" style="width: 200px;"></el-input>
            </el-form-item>
            <el-form-item label="短剧标题" prop="title">
                <el-input v-model="formInline.title" placeholder="请输入短剧标题" clearable @keyup.enter.native="search" @clear="search" style="width: 200px;"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
            </el-form-item>
            <el-form-item>
                <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="tableTh">
            <el-table :data="tableData.result" ref="singleTable" border highlight-current-row
                      @current-change="handleCurrentChangeTable" height="345" row-key="id" style="width: 100%" class="tableStyle table-radio">
                <!--<el-table-column type="selection" width="55" center>-->
                <!--</el-table-column>-->
                <el-table-column align="center" width="55" label>
                    <template slot-scope="scope">
                        <!--<el-radio @change.native="handleCurrentChangeTable(scope.row)" v-model="selected" :label="scope.row.id">&nbsp;</el-radio>-->
                        <el-checkbox @change.native="handleCurrentChangeTable(scope.row)" v-model="selected" :label="scope.row.id"></el-checkbox>
                    </template>
                </el-table-column>
                <el-table-column label="封面" width="100">
                    <template slot-scope="scope">
                        <img class="cover-td" :src="scope.row.picUrl" height="50" />
                    </template>
                </el-table-column>
                <el-table-column label="剧名" width="150">
                    <template slot-scope="scope">
                        <span>{{scope.row.title}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="albumId" label="剧目ID">
                </el-table-column>
                <el-table-column prop="isVerify" label="短剧审核状态" align="center" width="105">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.isVerify == 0" type="primary" effect="dark">未审核</el-tag>
                        <el-tag v-if="scope.row.isVerify == 1" type="warning" effect="dark">审核中</el-tag>
                        <el-tag v-if="scope.row.isVerify == 2" type="success" effect="dark">已审核</el-tag>
                        <el-tag v-if="scope.row.isVerify == 3" type="danger" effect="dark">审核不通过</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="statusOnline" label="状态" width="100">
                    <template slot-scope="scope">
                        <span v-if="scope.row.rackStatus == 0" class="danger-text">未上线</span>
                        <span v-if="scope.row.rackStatus == 1" class="succes-text">已上线</span>
                    </template>
                </el-table-column>
            </el-table>
            <div class="foot-table" style="text-align:center;">
                <el-pagination
                        @current-change="handleCurrentChange"
                        @size-change="handleSizeChange"
                        :page-sizes="[5, 20, 50, 100, 200, 500]"
                        :page-size="pageSize"
                        background
                        :current-page="currentPage"
                        layout="sizes, prev, pager, next, jumper, ->, total"
                        :total="tableData.totalNum">
                </el-pagination>
            </div>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialogTable">取 消</el-button>
            <el-button type="primary" @click="tableSureBtn">确 定</el-button>
        </div>
    </el-dialog>
</template>
<script>
    import { listVideoMedia } from "@/api/dysvzk/dymedia/add";
    export default {
        name: 'VideoTableMedia',
        props: {
            visible: {
                type: Boolean,
                required: true
            },
            selectVideo: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                innerVisible: this.visible,
                selected: [],
                formInline: {
                    albumId: '',
                    title: ''
                },
                tableData: {
                    pageSize: 20,
                    pageNo: 1,
                    totalPage: 1,
                    totalNum: 0,
                    result: []
                },
                currentPage: 1,
                pageSize: 5,
                currentRow: ''
            }
        },
        watch: {
            visible(newValue) {
                this.innerVisible = newValue;
                console.log(this.selectVideo)
                // 弹框显示赋值默认值
                this.$nextTick(()=>{
                    this.$refs.singleTable.setCurrentRow(this.selectVideo)
                })
            },
            innerVisible(newValue) {
                this.$emit('update:visible', newValue);
            }
        },
        mounted() {
            this.getTableVideo()
        },
        methods: {
            search () {
                this.currentPage = 1
                this.getTableVideo()
            },
            resetQuery() {
                this.$refs['formInline'].resetFields()
                this.getTableVideo()
            },
            // 分页
            handleCurrentChange (value) {
                this.currentPage = value
                this.getTableVideo()
            },
            // pageSize切换
            handleSizeChange (val) {
                this.pageSize = val
                this.currentPage = 1
                this.getTableVideo()
            },
            // 单选
            handleCurrentChangeTable(val) {
                console.log('单选')
                this.$refs.singleTable.setCurrentRow(val);
                this.currentRow = val
                // this.selected = val.id
                console.log(val)
                this.selected = [val.id]
            },
            // 确定按钮
            tableSureBtn() {
                this.$emit('videoSure', this.currentRow);
                this.$emit('cancelDialogVideo', false);
                // this.$refs.singleTable.setCurrentRow();
            },
            // 关闭弹框
            closeDialogTable () {
                console.log(22)
                this.$emit('cancelDialogVideo', false);
            },
            getTableVideo() {
                console.log("--选择短剧 媒资---",(localStorage.getItem('platform') == 'wx-sv' || localStorage.getItem('platform') == 'wx-gg-sv') ? 2 : 1)
                // 媒资管理
                let json2 = {
                    pageNo: this.currentPage,
                    pageSize: this.pageSize,
                    videoType: localStorage.getItem('platform') == 'wx-sv' || localStorage.getItem('platform') == 'wx-gg-sv' ? 2 : 1
                };
                let json1 = this.formInline;
                let paramJson = { ...json1, ...json2 };
                listVideoMedia(paramJson).then(response => {
                    if (response.data.head.flag === 0) {
                        this.tableData = response.data.content
                    } else {
                        this.$message.error(response.data.head.desc)
                    }
                });   
          
            },
        }
    }
</script>
